import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';

import {
    Input,
    TextArea,
    TimePicker,
    Form,
    Switch,
    Button
} from '@gpstrackit/gtc-react-controls';

const DateTime = (props) => {
    const { messages } = useIntl();
    const questionForm = Form.useForm();

    const {
        question,
        handleClose,
        updateQuestion
    } = props;

    const open = useSelector(state => state.dynamicFormsDesignRedux.openQuestionConfiguration);
    const loading = useSelector(state => state.dynamicFormsDesignRedux.loading);
    const [formData,  setFormData] = useState({});

    const [ minDate, setMinDate ] = useState();

    useEffect(() => {
        if (open && questionForm?.ref && question) {
            questionForm?.setValues({
                ...question,
                default: question?.attributes?.default ? new Date(question?.attributes?.default) : null,
                minimum: question?.attributes?.minimum ? new Date(question?.attributes?.minimum) : null,
                maximum: question?.attributes?.maximum ? new Date(question?.attributes?.maximum) : null,
            });
        }
    }, [questionForm?.ref, open, question]);

    return (
        <div>
            <Form
                ref={questionForm?.ref}
                loading={loading}
                onValidSubmit={(values) => {
                    let newQuestion = {
                        ...question,
                        label: values?.label,
                        placeHolder: values?.placeHolder,
                        help: values?.help,
                        required: values?.required,
                        readOnly: values?.readOnly,
                        attributes: {
                            default: values?.default ? values?.default?.toISOString() : null,
                            minimum: values?.minimum ? values?.minimum?.toISOString() : null,
                            maximum: values?.maximum ? values?.maximum?.toISOString() : null,
                        }
                    }

                    updateQuestion(newQuestion);
                }}
                onChangeValues={(values) => {
                    setFormData(values);
                    if (values?.minimum) {
                        setMinDate(values?.minimum);
                    }
                }}
            >
                <div>
                    <Form.Item
                        name="label"
                        label={messages['dynamicFormsDesign_label']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Input
                            id="label"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_label']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item 
                        name="placeHolder" 
                        label={messages['dynamicFormsDesign_placeholder']} 
                    >
                        <Input
                            id="placeHolder"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_placeholder']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item
                        name="help"
                        label={messages['dynamicFormsDesign_helpText']}
                    >
                        <TextArea
                            id="help"
                            placeholder={messages['dynamicFormsDesign_helpText']}
                            maxLength={1000}
                        />
                    </Form.Item>

                    <Form.Item
                        name="required"
                        label={messages['dynamicFormsDesign_required']}
                    >
                        <Switch
                            id="required"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        readOnly: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="readOnly"
                        label={messages['dynamicFormsDesign_readOnly']}
                    >
                        <Switch
                            id="readOnly"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        required: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="default"
                        label={messages['dynamicFormsDesign_defaultTime']}
                    >
                        <TimePicker
                            id="default"
                            placeholder={messages['dynamicFormsDesign_defaultTime']}
                            variant="dropdown"
                            timeIntervals={5}
                            format="h:mm A"
                            style={{
                                width: "100%"
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="minimum"
                        label={messages['dynamicFormsDesign_minimumTime']}
                    >
                        <TimePicker
                            id="minimum"
                            placeholder={messages['dynamicFormsDesign_minimumTime']}
                            variant="dropdown"
                            timeIntervals={5}
                            format="h:mm A"
                            style={{
                                width: "100%"
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="maximum"
                        label={messages['dynamicFormsDesign_maximumTime']}
                        rules={[
                            { minDate: minDate || null, message: `${messages['dynamicFormsDesign_minTimeValue']}: ${minDate ? moment(minDate).format("hh:mm a") : null}` }
                        ]}
                    >
                        <TimePicker
                            id="maximum"
                            placeholder={messages['dynamicFormsDesign_maximumTime']}
                            variant="dropdown"
                            timeIntervals={5}
                            format="h:mm A"
                            style={{
                                width: "100%"
                            }}
                        />
                    </Form.Item>
                </div>
            </Form>

            <div style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                    style={{ marginRight: 8 }}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.resetValues()
                        handleClose();
                    }}
                    variant='secondary'
                >
                    {messages['cancel']}
                </Button>

                <Button
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.submit();
                    }}
                    variant='primary'
                >
                    {messages['save']}
                </Button>
            </div>
        </div>
    );
}

export default DateTime;